export const REGEX = {
	NO_ESPACIOS: /^\S*$/,
};
